import {
  isDefined,
  isNotDefined,
  type AreaId,
  type CalendarEventId,
  type NotificationDestinationTarget,
} from '@terros/common'

export function resolveNotificationDestination(destination: NotificationDestinationTarget | null): string {
  if (isNotDefined(destination)) return '/notifications'
  switch (destination.kind) {
    case 'area':
    case 'areaAccounts':
      return areaManagementPath({ id: destination.id, accounts: destination.kind === 'areaAccounts' })
    case 'areasList':
      return '/areaManagement'
    case 'appointment':
      return calendarPath(destination.id, destination.date)
    case 'calendarDay':
      return calendarPath(undefined, destination.date)
    case 'team':
      return isDefined(destination.id) ? `/team/${encodeURIComponent(destination.id)}` : '/team'
    case 'conversation':
      return `/conversations/${encodeURIComponent(destination.convoId)}`
    case 'meetingCheckIn':
    case 'notifications':
      return '/notifications'
  }
}

export function notificationDestinationExplanation(
  destination: NotificationDestinationTarget | null
): string | undefined {
  if (destination?.kind === 'meetingCheckIn')
    return 'Meeting check-in is available in the mobile app. There is no web meeting page yet.'
  if (isNotDefined(destination) || destination.kind === 'notifications')
    return 'This item is no longer available or you no longer have access.'
  return undefined
}

function areaManagementPath({ id, accounts }: { id: AreaId; accounts: boolean }): string {
  const query = new URLSearchParams({ area: id })
  if (accounts) query.set('view', encodeURIComponent(JSON.stringify('list')))
  return `/areaManagement?${query}`
}

function calendarPath(eventId?: CalendarEventId, date?: string): string {
  const query = new URLSearchParams()
  if (isDefined(eventId)) query.set('eventId', eventId)
  if (isDefined(date)) {
    query.set('time', `${date}T00:00:00`)
    query.set('viewRange', encodeURIComponent(JSON.stringify('day')))
  }
  return query.size > 0 ? `/calendar?${query}` : '/calendar'
}
